export { Cards4 } from './translator';
